module.exports = {
  "country": "GR",
  "artist": "Koza Mostra & Agathonas Iakovidis",
  "song": "Alcohol is free",
  "year": "2013",
  "place": "6",
  "spotify": "6dAnm4XPEEfrGsAHTkhCWh"
};